<template>
  <el-container>
    <el-header style="background-color: #fff">
      <el-menu :router="true" mode="horizontal">
        <el-menu-item index="/AboutIndex">关于我</el-menu-item>
        <el-menu-item index="/BlogIndex">个人博客</el-menu-item>
        <el-menu-item index="/LogIndex">我的日志</el-menu-item>
      </el-menu>
    </el-header>

    <el-container>
      <el-aside
        width="200px"
        style="
          background-color: #fff;
          border-right: 1px solid rgb(204, 204, 204);
        "
        ><div class="div-UserInfo">
          <div class="divIcon">
            <el-image
              src="https://avatars.githubusercontent.com/u/14285531?v=4"
              fit="cover"
              style="border-radius: 120px; width: 120px; height: 120px"
            ></el-image>
          </div>
          <div class="divTitle">爱学习的我</div>

          <div class="divBlogInfo">
            <div class="div-BlogAge">
              <div class="div-Value">1年7个月</div>
              <div class="div-Key">园龄</div>
            </div>

            <div class="div-fansNum">
              <div class="div-Value">43</div>
              <div class="div-Key">粉丝</div>
            </div>

            <div class="div-flowNum">
              <div class="div-Value">16</div>
              <div class="div-Key">关注</div>
            </div>
          </div>
        </div></el-aside
      >

      <el-container>
        <el-main style="background-color: #fff">
          <router-view />
        </el-main>

        <el-footer
          style="
            background-color: rgb(233, 238, 243);
            vertical-align: middle;
            text-align: center;
          "
        >
          <el-link :underline="false" href="https://beian.miit.gov.cn/" class="footerTxt"
            >备案号：豫ICP备2021034630号-1</el-link
          >
        </el-footer>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import 'element-ui/lib/theme-chalk/display.css'
export default {
  name: 'App',
  data () {
    return {}
  },
  methods: {}
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
<style lang="sss" scoped>
.div-UserInfo {
  width: 100%;
}
.divIcon,
.divTitle {
  margin-top: 20px;
  color: rgb(10, 11, 29);
}

.divIcon {
  height: 120px;
  width: 120px;
  margin-left: 40px;
}
.divTitle {
  text-align: center;
  width: 100%;
  line-height: 12px;
  color: rgb(32, 32, 32);
  font-weight: bolder;
}
.footerTxt {
  padding-left: 20px;
}

.divBlogInfo {
  margin-top: 20px;
  display: block;
  float: left;
  width: 100%;
  font-size: 14px;
  text-align: center;
}

.div-BlogAge,
.div-fansNum,
.div-flowNum {
  display: inline;
  float: left;
  width: 60px;
  margin-right: 6px;
  color: rgb(32, 32, 32);
  cursor: pointer;
}

.div-BlogAge:hover,
.div-fansNum:hover,
.div-flowNum:hover {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/App.vue